<template>
    <v-card class="pa-0" :color="headerColor" :flat="true" :rounded="true" :border="border">
        <v-card-title class="character-heading d-flex align-center ga-2" :class="{ 'character-heading--small': small }" :style="{ color: characterColorCss }">
            <v-icon :icon="'ko:character-' + character.name.toLowerCase()"
                    :color="characterColorCss"
                    :size="small ? 18 : 32"
            />
            <span>{{ character.name }}</span>
            <tier-badge v-if="isOwned"
                        :tier="character.tier"
                        :color="characterColor || 'info'"
                        class="ml-auto elevation-3"
            />
            <div v-else-if="$slots.badge" class="ml-auto">
                <slot name="badge" />
            </div>
        </v-card-title>
        <img class="character-detail"
             :src="`/assets/banners/characters/detail/${character.name.toLowerCase()}.png`"
             :alt="character.name"
        >
    </v-card>
</template>

<script setup>
    import {computed} from "vue";
    import {useCharacterColor} from "@/composables/useCharacterColor";
    import TierBadge from "@/components/TierBadge";

    const props = defineProps({
        character: {
            type: Object,
        },
        title: {
            type: Boolean,
            default: () => false,
        },
        customTitle: {
            type: String,
            default: () => null,
        },
        headerColor: {
            type: String,
            default: () => null,
        },
        border: {
            type: Boolean,
            default: () => false,
        },
        small: {
            type: Boolean,
            default: () => false,
        },
    });

    const {getCharacterColor, getCharacterColorCss} = useCharacterColor();
    const characterColor = computed(() => getCharacterColor(props.character?.name));
    const characterColorCss = computed(() => getCharacterColorCss(props.character?.name));
    const isOwned = computed(() => typeof props.character?.tier === "number");
</script>

<style scoped>
    .character-heading {
        justify-content: flex-start;
    }
    .character-heading--small {
        font-size: 0.9rem;
        line-height: 1.2rem;
    }
    .character-detail {
        display: block;
        width: 100%;
        aspect-ratio: 2 / 1;
        object-fit: fill;
    }
</style>
